import { defineNuxtPlugin, useRouter, useState } from '#imports'

/**
 * Resets the counter after a successful navigation
 * router.afterEach hook is called after all redirections are processed
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const redirectionsCount = useState('redirections-count', () => 0)

  router.afterEach((to, from, failure) => {
    if (!failure) {
      redirectionsCount.value = 0
    }
  })
})
